module.exports = __webpack_public_path__ + "static/media/grey_door_car.39e595d3.jpg";